import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import {
    addErrors,
    setBrands,
    setModels,
    setGenerations,
    setGenerationSelected,
    setGenerationIdSelected,
    setGenerationObject,
    setFuelTypeIndex,
    setBrandId,
    setModelId,
    setFuelTypesGroup,
    setTankSize
} from '../../../../../../../../redux/actions'
import { SelectVehicle } from './select-vehicle'

const SelectVehicleConnected = props => {
    const { intl, validatorCallback } = props
    const dispatch = useDispatch()

    const customerProps = {
        activationCode: useSelector(state => state.activationCode.activationCode),
        customerNumber: useSelector(state => state.customerNumber.customerNumber)
    }

    const mapStateToProps = {
        brandIdState: useSelector(state => state.brandId.brandId),
        brands: useSelector(state => state.brands.brands),
        fuelTypeIndexState: useSelector(state => state.fuelTypeIndex.fuelTypeIndex),
        fuelTypesGroupState: useSelector(state => state.fuelTypesGroup.fuelTypesGroup),
        generationNoState: useSelector(state => state.generationSelected.generationSelected),
        generations: useSelector(state => state.generations.generations),
        intl,
        modelIdState: useSelector(state => state.modelId.modelId),
        models: useSelector(state => state.models.models),
        tankSize: useSelector(state => state.tankSize.tankSize),
        validatorCallback
    }

    const mapDispatchToProps = {
        addErrors: err => dispatch(addErrors(err)),
        setBrandId: brandId => dispatch(setBrandId(brandId)),
        setBrands: brands => dispatch(setBrands(brands)),
        setFuelTypeIndex: ftIndex => dispatch(setFuelTypeIndex(ftIndex)),
        setFuelTypesGroup: ftGroup => dispatch(setFuelTypesGroup(ftGroup)),
        setGenerationIdSelected: generationId => dispatch(setGenerationIdSelected(generationId)),
        setGenerationObject: genObj => dispatch(setGenerationObject(genObj)),
        setGenerationSelected: generation => dispatch(setGenerationSelected(generation)),
        setGenerations: generations => dispatch(setGenerations(generations)),
        setModelId: modelId => dispatch(setModelId(modelId)),
        setModels: models => dispatch(setModels(models)),
        setTankSize: tankSize => dispatch(setTankSize(tankSize))
    }

    return (
        <SelectVehicle
            {...{
                ...mapStateToProps,
                ...mapDispatchToProps,

                ...customerProps,
                ...props
            }}
        />
    )
}

SelectVehicleConnected.propTypes = {
    errorTankSize: PropTypes.string,
    intl: PropTypes.objectOf(PropTypes.func),
    setTankSize: PropTypes.func,
    setTankSizeError: PropTypes.func,
    validTankSizeField: PropTypes.func,
    validatorCallback: PropTypes.func
}

export { SelectVehicleConnected }
